import {
  List,
  Datagrid,
  TextField,
  DateField,
  SelectInput,
  SearchInput,
  FilterButton,
  TopToolbar,
} from 'react-admin';
import { Chip } from '@mui/material';
import { StatusChip } from '../../components/support/StatusChip';
import { PriorityChip } from '../../components/support/PriorityChip';

const ticketFilters = [
  <SearchInput key="search" source="search" alwaysOn placeholder="Search by subject or user" />,
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: 'open', name: 'Open' },
      { id: 'in_progress', name: 'In Progress' },
      { id: 'waiting_user', name: 'Waiting User' },
      { id: 'closed', name: 'Closed' },
    ]}
  />,
  <SelectInput
    key="priority"
    source="priority"
    choices={[
      { id: 'urgent', name: 'Urgent' },
      { id: 'high', name: 'High' },
      { id: 'medium', name: 'Medium' },
      { id: 'low', name: 'Low' },
    ]}
  />,
  <SelectInput
    key="assigned_to"
    source="assigned_to"
    choices={[
      { id: -1, name: 'Unassigned' },
      // TODO: Load from API - list of admin users
    ]}
  />,
];

const TicketListActions = () => (
  <TopToolbar>
    <FilterButton />
  </TopToolbar>
);

const UnreadBadge = ({ source, record }: any) => {
  const count = record?.[source] || 0;
  if (count === 0) return null;

  return <Chip label={count} color="error" size="small" />;
};

export const TicketList = () => (
  <List
    filters={ticketFilters}
    actions={<TicketListActions />}
    perPage={50}
    sort={{ field: 'updated_at', order: 'DESC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="#" />
      <TextField source="username" />
      <TextField source="subject" />
      <StatusChip source="status" />
      <PriorityChip source="priority" />
      <TextField source="assigned_username" label="Assigned To" />
      <TextField source="message_count" label="Messages" />
      <UnreadBadge source="unread_count" />
      <DateField source="updated_at" showTime />
    </Datagrid>
  </List>
);
